<template>
  <v-dialog :retain-focus="false" :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields.title }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>

      <v-card-text style="max-height: 70vh; overflow-y: auto">
        <div class="mb-4">
          <label class="label-input">Section</label>
          <v-row>
            <v-col cols="12" md="8">
              <v-text-field v-model="fields.title" label="Name" hide-details />
            </v-col>
            <v-col cols="12" md="4">
              <v-checkbox v-model="fields.enableAnchor" label="Enable Anchor" hide-details />
            </v-col>
          </v-row>
        </div>

        <div class="mb-4">
          <SectionSettingsContainerFuild :settings="fields.settings" :container-page="fields.containerPage" />
        </div>

        <div class="mb-4 group-item">
          <label class="label-input">Content</label>
          <ckeditor :editor="editor" v-model="fields.content" :config="editorConfig" />
        </div>

        <div class="mb-4 group-item">
          <label class="label-input">Marquee Settings</label>
          <v-checkbox v-model="fields.pauseOnHover" label="Pause scroll animation on hover" hide-details />
        </div>

        <div class="mb-4">
          <div class="d-flex justify-space-between align-center">
            <label class="label-input mb-0">Reviews ({{ fields.items.length }})</label>
            <v-btn small text color="primary" @click="handleAddItem">
              <v-icon size="16">mdi-plus</v-icon>
              <span>Add review</span>
            </v-btn>
          </div>
          <v-expansion-panels accordion class="mt-2">
            <v-expansion-panel v-for="(item, index) in fields.items" :key="`saintbrand-infinite-marquee-item-${index}`">
              <v-expansion-panel-header>
                <div class="d-flex justify-space-between align-center">
                  <span>
                    Review {{ index + 1 }}
                    <small class="text--secondary ml-2">({{ getCardPositionLabel(index) }})</small>
                  </span>
                  <v-btn icon @click.stop="handleRemoveItem(index)">
                    <v-icon size="20" color="#ff6c6c">mdi-delete</v-icon>
                  </v-btn>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <div class="mb-4">
                  <label class="mb-2 d-block">Review Image</label>
                  <UploadImage
                    :ref="`uploadComponent${index}`"
                    @callback="obj => handleUploadReviewImage(obj, index)"
                    :image="{ imageSrc: item.review.image }"
                    :height="`150`"
                    :typeUpload="'image'"
                    @callbackDelete="handleRemoveReviewImage(index)"
                  />
                </div>

                <div class="review-group">
                  <v-text-field v-model="item.review.name" label="Name" class="mb-2" />
                  <div class="mb-3">
                    <label class="mb-2 d-block">Avatar</label>
                    <UploadImage
                      @callback="obj => handleUploadReviewAvatar(obj, index)"
                      :image="{ imageSrc: item.review.avatar }"
                      :height="`80`"
                      :typeUpload="'image'"
                      @callbackDelete="item.review.avatar = ''"
                    />
                  </div>
                  <v-textarea v-model="item.review.content" outlined label="Review content" />
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
      </v-card-text>

      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import { updateHtmlFromData } from '../common/html/update.js';
import SectionSettingsContainerFuild from './common/section-settings-container-fuild.vue';
import UploadImage from '@/components/form/uploadFile/UpdateImage.vue';
import productReviewsJson from '@/assets/json/product-reviews.json';

const createEmptyReview = () => ({
  image: '',
  avatar: '',
  name: '',
  content: 'Review content',
});

const normalizeItem = item => {
  if (item?.review) {
    return {
      review: {
        ...createEmptyReview(),
        ...item.review,
      },
    };
  }

  const legacyImage = item?.image || '';
  const legacyTop = item?.topReview || {};
  const legacyBottom = item?.bottomReview || {};
  const legacyReview = legacyTop.name || legacyTop.content ? legacyTop : legacyBottom;

  return {
    review: {
      ...createEmptyReview(),
      image: legacyImage || legacyReview.image || '',
      avatar: legacyReview.avatar || '',
      name: legacyReview.name || '',
      content: legacyReview.content || '',
    },
  };
};

export default {
  name: 'saintbrand-infinite-marquee-section-editor',
  components: {
    SectionSettingsContainerFuild,
    UploadImage,
  },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      fields: {
        title: 'Saintbrand Infinite Marquee',
        enableAnchor: false,
        content: '<h2 style="text-align: center"><strong>Real Results from Real People</strong></h2>',
        pauseOnHover: true,
        settings: {
          paddingTop: true,
          paddingBottom: true,
          backgroundColor: '#f5f5f5',
          textColor: '#000000',
          overlayColor: '#000000',
          overlayOpacity: 0,
          showOverlay: false,
          backgroundImage: '',
        },
        containerPage: {
          enableStyle: false,
          background: '#FFFFFF',
        },
        items: [],
      },
    };
  },
  mounted() {
    this.applyExtract(this.sectionEditor.sectionExtract);
  },
  watch: {
    sectionEditor: {
      handler(newVal) {
        if (newVal && newVal.sectionExtract) {
          this.applyExtract(newVal.sectionExtract);
        }
      },
      deep: true,
    },
  },
  methods: {
    getCardPositionLabel(index) {
      return index % 2 === 0 ? 'card on top' : 'card on bottom';
    },
    applyExtract(extract) {
      if (!extract) return;
      this.fields = {
        ...this.fields,
        ...extract,
        settings: { ...this.fields.settings, ...(extract.settings || {}) },
        containerPage: { ...this.fields.containerPage, ...(extract.containerPage || {}) },
        items: Array.isArray(extract.items) ? extract.items.map(normalizeItem) : this.fields.items,
      };
    },
    handleAddItem() {
      const index = this.fields.items.length;
      const reviewer = productReviewsJson[index % productReviewsJson.length] || {};

      this.fields.items.push({
        review: {
          ...createEmptyReview(),
          image: reviewer.avatar || '',
          avatar: reviewer.avatar || '',
          name: reviewer.fullName || '',
        },
      });
    },
    handleRemoveItem(index) {
      this.fields.items.splice(index, 1);
    },
    handleUploadReviewImage(obj, index) {
      if (obj && obj.imageSrc) {
        this.fields.items[index].review.image = obj.imageSrc;
      }
    },
    handleRemoveReviewImage(index) {
      this.fields.items[index].review.image = '';
    },
    handleUploadReviewAvatar(obj, index) {
      if (obj && obj.imageSrc) {
        this.fields.items[index].review.avatar = obj.imageSrc;
      }
    },
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const payload = {
        ...this.fields,
        items: (this.fields.items || []).map(item => ({
          review: {
            image: item.review?.image || '',
            avatar: item.review?.avatar || '',
            name: item.review?.name || '',
            content: item.review?.content || '',
          },
        })),
      };
      const updateHtml = updateHtmlFromData.sectionSaintbrandInfiniteMarquee(this.sectionEditor.section.html, payload);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields.title,
        html: updateHtml,
      });
      this.$emit('close');
    },
  },
};
</script>

<style scoped lang="scss">
.group-item {
  padding: 15px 10px;
  border-radius: 10px;
  border: 1px solid #e0e0e0;
}
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}
.review-group {
  padding: 12px;
  border: 1px solid #eee;
  border-radius: 8px;
}
::v-deep .ck-editor__editable_inline,
::v-deep .ck-editor__editable {
  min-height: 120px;
}
</style>
